import { Link } from "react-router-dom";

export function Logo({ className = "", onDark = false }) {
  return (
    <Link to="/" data-testid="nav-brand-logo" className={`flex items-center gap-2 ${className}`}>
      <img src="/brand-logo.png" alt="Ustayla" className="h-9 w-9 object-contain" />
      <span className={`text-2xl font-extrabold tracking-tight ${onDark ? "text-white" : "text-emerald-600"}`}>ustayla</span>
    </Link>
  );
}
